module.exports = __webpack_public_path__ + "img/brt_alberic_bordeleaux_0.d34bbdab.png";